import PropTypes from 'prop-types';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  makeStyles,
  DialogContentText,
} from '@material-ui/core';
import RoundedButton from 'components/Shared/RoundedButton';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  actions: {
    padding: theme.spacing(1, 3, 2, 3),
  },
}));

const InfoDialog = ({ open, onClose, title, content, ...rest }) => {
  const { en: { btn } } = useSelector((state) => state.i18n);
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby='info-title'
      disableBackdropClick
      disableEscapeKeyDown
      {...rest}
      style={{
        zIndex: 130000000000,
      }}
    >
      <DialogTitle id='info-title'>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{content}</DialogContentText>
      </DialogContent>
      <DialogActions classes={{ root: classes.actions }}>
        <RoundedButton
          onClick={onClose}
          variant='contained'
          color='primary'
          size='small'
        >
          {btn.ok}
        </RoundedButton>
      </DialogActions>
    </Dialog>
  );
};

InfoDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
};

export default InfoDialog;
